import { Injectable } from '@angular/core';

export interface AppConfigResponse {
    paymentsPublicKey?: string | null;
    recaptchaV3SiteKey?: string | null;
    bugReporterEnabled?: boolean | null;
    googleMapsBrowserKey?: string | null;
}

@Injectable({
    providedIn: 'root',
})
export class RuntimeConfigService {
    private _config: AppConfigResponse = {};

    set(config: AppConfigResponse | null | undefined): void {
        this._config = config ?? {};
    }

    getRecaptchaV3SiteKey(): string | null {
        return this._config.recaptchaV3SiteKey ?? null;
    }

    getPaymentsPublicKey(): string | null {
        return this._config.paymentsPublicKey ?? null;
    }

    /**
     * Referrer-restricted Google key for Maps JS + Places, owned by core
     * (GOOGLE_MAPS_BROWSER_KEY) and delivered via /api/config so no key ships in
     * the bundle. Every other Google lookup goes through core (SD-9534).
     */
    getGoogleMapsBrowserKey(): string | null {
        return this._config.googleMapsBrowserKey ?? null;
    }

    /**
     * Global, org-agnostic kill switch for the super-only "Report a bug" tool,
     * owned by core (BUG_REPORTER_ENABLED) and delivered via /api/config. When
     * false, the whole surface (button + super-admin console) stays hidden.
     */
    isBugReporterEnabled(): boolean {
        return this._config.bugReporterEnabled === true;
    }
}
